import { Controller } from '@hotwired/stimulus';

// PDF dropzone: browse / drag & drop a file, show its name, or remove it.
// Keeps the real <input type="file"> in sync so the form submits the file.
export default class extends Controller {
  static targets = ['input', 'prompt', 'preview', 'filename', 'status'];
  static classes = ['drag'];

  browse() {
    this.inputTarget.click();
  }

  picked() {
    const file = this.inputTarget.files[0];
    if (file) this.show(file.name);
  }

  dragover(event) {
    event.preventDefault();
    this.element.classList.add('is-dragover');
  }

  dragleave() {
    this.element.classList.remove('is-dragover');
  }

  drop(event) {
    event.preventDefault();
    this.element.classList.remove('is-dragover');
    const file = event.dataTransfer.files[0];
    if (!file) return;

    this.inputTarget.files = event.dataTransfer.files;
    this.show(file.name);
  }

  remove() {
    this.inputTarget.value = '';
    this.promptTarget.hidden = false;
    this.previewTarget.hidden = true;
  }

  show(name) {
    this.filenameTarget.textContent = name;
    // On the edit screen the preview starts on the current file; once a new one
    // is picked, switch the status label (e.g. "ready to import").
    const newLabel = this.element.dataset.dropzoneNewLabel;
    if (this.hasStatusTarget && newLabel) this.statusTarget.textContent = newLabel;
    this.promptTarget.hidden = true;
    this.previewTarget.hidden = false;
  }
}
